import React from "react";
import "./Brown_btn.css";
import { Button } from "react-bootstrap";

function Brown_btn({btnText}) {
  return (
    <>
      <section className="Brown_btn_holder">
        <Button className="Brown_btn">{btnText}</Button>
      </section>
    </>
  );
}

export default Brown_btn;
